import Http from '@/utils/http'
import NCommonApi = global.NCommonApi
import { RequestType } from '@/typings/enum/Common'

class Common extends Http {
  // 获取用户信息
  public async requestUserInfo() {
    return await super.request<NCommonApi.UserInfo>({
      url: '/api/openPlatform/wallet/userInfo',
      method: RequestType.Get
    })
  }
}

export default Common
